/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class StateDebouncer {
/**
 * The Observable that lets other classes subscribe to global state changes
 */
private _change = new Subject<void>();
/**
 * @return {?}
 */
public get change(): Observable<void> {
        return this._change.asObservable();
    }
private nbChanges = 0;
/**
 * @return {?}
 */
public changeStart() {
        this.nbChanges++;
    }
/**
 * @return {?}
 */
public changeDone() {
        if (--this.nbChanges === 0) {
            this._change.next();
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StateDebouncer_tsickle_Closure_declarations() {
/** @type {?} */
StateDebouncer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StateDebouncer.ctorParameters;
/**
 * The Observable that lets other classes subscribe to global state changes
 * @type {?}
 */
StateDebouncer.prototype._change;
/** @type {?} */
StateDebouncer.prototype.nbChanges;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
